import type { Cart, ShippingOption } from '@sshop/domain';

/** A chosen city always takes precedence, including cities excluded from the offer. */
export function freeDeliveryOption(options: readonly ShippingOption[] = [], selected?: ShippingOption | null) {
  const eligible = (option: ShippingOption) => option.noticeEnabled &&
    option.freeShippingThreshold != null && Number.isFinite(option.freeShippingThreshold) &&
    option.freeShippingThreshold > 0 && option.price.amount > 0;
  if (selected) return eligible(selected) ? selected : undefined;
  return options.filter(eligible).reduce<ShippingOption | undefined>((best, next) =>
    !best || next.freeShippingThreshold! < best.freeShippingThreshold! ? next : best, undefined);
}

export function deliveryProgress(cart: Cart, threshold: number) {
  const totalCents = Math.max(0, Math.round((cart.totals.subtotal.amount - cart.totals.discount.amount) * 100));
  const thresholdCents = Math.round(threshold * 100);
  return {
    total: totalCents / 100,
    remaining: Math.max(0, thresholdCents - totalCents) / 100,
    percent: Math.min(100, totalCents / thresholdCents * 100),
  };
}

export function deliveryPrice(option: ShippingOption, cart: Cart) {
  const threshold = option.freeShippingThreshold;
  const free = threshold != null && deliveryProgress(cart, threshold).remaining === 0;
  return { ...option.price, amount: free ? 0 : option.price.amount };
}
